 const versionData = {
    version:2.0,
    date:"28/02/2023"
 };
 export default versionData